import React, { useEffect, useRef, useState } from "react";
import { Eraser, Pen } from "lucide-react";

export const SignaturePad = ({ label, value, onChange, testid }) => {
  const ref = useRef(null);
  const [drawing, setDrawing] = useState(false);
  const [hasInk, setHasInk] = useState(Boolean(value));

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const dpr = window.devicePixelRatio || 1;
    const cssWidth = canvas.clientWidth;
    const cssHeight = canvas.clientHeight;
    canvas.width = cssWidth * dpr;
    canvas.height = cssHeight * dpr;
    const ctx = canvas.getContext("2d");
    ctx.scale(dpr, dpr);
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#111619";
    ctx.lineWidth = 2.2;
    // restore from value if present
    if (value) {
      const img = new Image();
      img.onload = () => ctx.drawImage(img, 0, 0, cssWidth, cssHeight);
      img.src = value;
      setHasInk(true);
    }
  }, [value]);

  const pos = (e) => {
    const rect = ref.current.getBoundingClientRect();
    const t = e.touches ? e.touches[0] : e;
    return { x: t.clientX - rect.left, y: t.clientY - rect.top };
  };

  const start = (e) => {
    e.preventDefault();
    setDrawing(true);
    setHasInk(true);
    const ctx = ref.current.getContext("2d");
    const p = pos(e);
    ctx.beginPath();
    ctx.moveTo(p.x, p.y);
  };
  const move = (e) => {
    if (!drawing) return;
    e.preventDefault();
    const ctx = ref.current.getContext("2d");
    const p = pos(e);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
  };
  const end = () => {
    if (!drawing) return;
    setDrawing(false);
    onChange?.(ref.current.toDataURL("image/png"));
  };

  const clear = () => {
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    setHasInk(false);
    onChange?.(null);
  };

  return (
    <div data-testid={testid}>
      <div className="flex items-center justify-between mb-2">
        <div className="font-display uppercase tracking-widest text-[11px] text-[#3f4b52] flex items-center gap-2">
          <Pen size={12} /> {label}
        </div>
        <button
          type="button"
          onClick={clear}
          className="text-xs text-[#dc2626] hover:underline inline-flex items-center gap-1"
        >
          <Eraser size={12} /> Clear
        </button>
      </div>
      <div className="border-2 border-dashed border-[#cfd7db] rounded-md bg-white relative">
        <canvas
          ref={ref}
          onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
          onTouchStart={start} onTouchMove={move} onTouchEnd={end}
          className="w-full h-40 touch-none block"
        />
        {!hasInk && (
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none text-xs text-[#9aa6ad] font-display uppercase tracking-widest">
            Sign here
          </div>
        )}
      </div>
    </div>
  );
};

export default SignaturePad;
